export class MovieCrew {
  constructor(data) {
    data = data || {};
    this.name = data.name ?? "";
    this.role = data.role ?? 0;
  }
}